import { IDBPDatabase, IDBPTransaction, openDB } from "idb";

import { migration as migrationV0001 } from "./migrations/v0001";
import { migration as migrationV0002 } from "./migrations/v0002";
import { migration as migrationV0003 } from "./migrations/v0003";
import { migration as migrationV0004 } from "./migrations/v0004";
import { migration as migrationV0005 } from "./migrations/v0005";
import {
  Schema as SchemaV0006,
  migration as migrationV0006,
} from "./migrations/v0006";

export type Schema = SchemaV0006;
const VERSION = 6;
const DB_NAME = "UniDeck";
const migrations: ((
  db: IDBPDatabase<any>,
  tx: IDBPTransaction<any, any>,
) => Promise<void>)[] = [
  migrationV0001,
  migrationV0002,
  migrationV0003,
  migrationV0004,
  migrationV0005,
  migrationV0006,
];
let ready: Promise<IDBPDatabase<Schema>> | undefined;

// Kicked off (not awaited) in main.tsx so first render doesn't block on
// IndexedDB; consumers await getDB(), which resolves once the DB is open.
export const createDB = () => {
  ready ??= openDB<Schema>(DB_NAME, VERSION, {
    async upgrade(db, oldVersion, newVersion, tx) {
      if (!newVersion) {
        return;
      }

      for (let i = oldVersion; i < newVersion; i++) {
        await migrations[i](db as any, tx as any);
      }
    },
  });

  return ready;
};

export const getDB = () => {
  if (!ready) {
    throw new Error("Database not initialized");
  }

  return ready;
};
